import Immutable from 'seamless-immutable';
import _ from 'lodash';

const SET_PAGINATION = 'SET_PAGINATION';
const INIT_STATE = 'INIT_STATE';

const reducerName = `pagination`;
const createReducerDotPathName = combineName => `${combineName}.${reducerName}`;

const createActionName = (combineName, name) =>
  `app/${createReducerDotPathName(combineName)}/${name}`;
export const getState = (state, parentName) =>
  _.get(state, createReducerDotPathName(parentName));

const createPaginationReducer = parentName => {
  function stateDefault() {
    return {
      currentPage: 0,
      pageCount: 0,
      perPage: 0,
      totalCount: 0
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(parentName, SET_PAGINATION):
        return state.merge(action.data);
      case createActionName(parentName, INIT_STATE):
        return Immutable(stateDefault());
      default:
        return state;
    }
  };
};

export function createReduceObject(parentName) {
  const reduceObject = {};
  reduceObject[reducerName] = createPaginationReducer(parentName);
  return reduceObject;
}

// ACTIONS CREATOR
export const setPagination = (parentName, data) => ({
  type: createActionName(parentName, SET_PAGINATION),
  data
});
export const initState = parentName => ({
  type: createActionName(parentName, INIT_STATE)
});

// SELECTORS
export const selectPaginationData = (parentName, state) =>
  getState(state, parentName);



// WEBPACK FOOTER //
// ./src/mt-react-common/common/reducers/_pagination/reducer.js